import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import escapeRegExp from 'lodash-es/escapeRegExp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboard } from '@fortawesome/pro-regular-svg-icons/faClipboard';

import Styles from './styles.module.scss';
import { PREMIUM_PUBLICATIONS_PATH } from '../../../../data/directory/constants';
import Preloader from '../../../Preloader';

const cx = classNames.bind(Styles);

const PremiumPublicationsCard = ({ publicationLists, highlight = '', loading }) => {
  if (loading) {
    return (
      <div className={cx('loadingContainer')}>
        <Preloader
          loading
          centered
        />
      </div>
    );
  }
  if (publicationLists.length > 0) {
    return (
      <div className={cx('premiumPublicationsCard')}>
        {publicationLists?.map((list) => (
          <PublicationCard
            key={list.id}
            card={list}
            highlight={highlight}
          />
        ))}
      </div>
    );
  }
  return (
    <div className={cx('noPublicationMessage')}>
      <div className={cx('messageIcon')}>
        <FontAwesomeIcon icon={faClipboard} />
      </div>
      <p className={cx('publicationMessage')}>We currently have no Publications for this search</p>
    </div>
  );
};

export default PremiumPublicationsCard;

const PublicationCard = ({ card, highlight }) => {
  const {
    id, name, cached_logo_url: icon,
  } = card;
  const url = `${PREMIUM_PUBLICATIONS_PATH}/${id}-${name.replace(/[^a-zA-Z ]/g, '').split(' ').join('').toLowerCase()}`;
  const regex = new RegExp(`(${escapeRegExp(highlight)})`, 'gi');
  const parts = name.split(regex);
  return (
    <Link to={url} className={cx('publication-card')}>
      <div className={cx('icon')}>
        <img src={icon} alt={name} />
      </div>
      {!highlight.trim() ? <span className={cx('name')}>{name}</span> : (
        <span className={cx('name')}>
          {parts.map(
            (part, index) => (
              regex.test(part)
                ? <mark key={part + index}>{part}</mark>
                : <span key={part}>{part}</span>
            ),
          )}
        </span>
      )}
    </Link>
  );
};
